/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import OldPersonalDetails from "./PersonalDetails.container";

export default OldPersonalDetails;
